import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { clientFormDefault } from "@factory/form/form.default";
import { ClientFormRule, ClientFormSchema } from "@factory/form/form.rule";
import { useQyCreateClient } from "@factory/query/client.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewClient() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateClient } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Client is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addClient, isLoading: isCreating } =
    useQyCreateClient(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ClientFormSchema>({
    defaultValues: clientFormDefault,
    resolver: zodResolver(ClientFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ClientFormSchema) => {
    const formData = mapCreateClient(form);
    addClient(formData);
  };
  const handleValidateError = (err: FieldErrors<ClientFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
